import axios from 'axios'

const API = axios.create({
  baseURL: `${
    process.env.NODE_ENV === 'development' ? 'http://localhost' : 'https://api.connectm.com.br'
  }:3333`,
})

API.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('@Connectm:token')

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

API.interceptors.response.use(
  (response: any) => {
    return response
  },
  (error) => {
    if (401 === error.response.status || 403 === error.response.status) {
      localStorage.removeItem('@Connectm:token')
      window.location.href = '/login'
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default API
